module.exports = __webpack_public_path__ + "static/media/birds_fly_from-window.43fe26c5.gif";